/* assets/vo-lifestyle-analyse-core.js
   - Baut das Formular aus vo-fragen.txt (Frage#code; 1/2/3 = Alter/Geschlecht/E-Mail)
   - Zählt a..j wie Classic-ASP, schreibt Auswertung in contact[Auswertung]
   - Sofort-Filter (Chips) pro Kategorie
   - Overlay (Toast) mit ok/err + Auto-Close
   - Validierung: Mindestens 1 Checkbox (Q1–Q49) muss gewählt sein
*/
(function(){
  'use strict';

  function initRoot(root){
    if (!root) return;

    var form     = root.querySelector('#vo-sn-la-form');
    var wrap     = root.querySelector('#vo-questions');
    var chipbar  = root.querySelector('.vo-chipbar');
    var hiddenOut= root.querySelector('#vo-sn-auswertung');

    if (!form || !wrap || !hiddenOut) return;

    // ---- Overlay -----------------------------------------------------------
    var ov   = root.querySelector('#vo-flash'); // im gleichen Root
    var card = ov ? ov.querySelector('.vo-flash-card') : null;
    var txt  = ov ? ov.querySelector('.vo-flash-text') : null;
    var btnX = ov ? ov.querySelector('.vo-flash-close') : null;
    var timerId = null;

    function closeFlash(){
      if (!ov) return;
      ov.classList.remove('is-open');
      if (timerId){ clearTimeout(timerId); timerId = null; }
      document.removeEventListener('keydown', onEsc);
    }
    function onEsc(e){ if (e.key === 'Escape') closeFlash(); }

    function openFlash(type, message, ms){
      if (!ov || !card || !txt) return;
      txt.textContent = message || '';
      card.classList.remove('ok','err');
      card.classList.add(type === 'ok' ? 'ok' : 'err'); // err = roter linker Rand
      ov.classList.add('is-open');
      if (timerId) clearTimeout(timerId);
      timerId = setTimeout(closeFlash, ms || 5000);
      document.addEventListener('keydown', onEsc);
    }
    // Controls
    if (btnX) btnX.addEventListener('click', closeFlash);
    if (ov)   ov.addEventListener('click', function(e){ if (e.target === ov) closeFlash(); });

    // Serverseitige Meldung aus Data-Attributen
    (function(){
      var type = root.getAttribute('data-flash-type') || '';
      var text = root.getAttribute('data-flash-text') || '';
      if (type && text) openFlash(type, text, 5000);
    })();

    // ---- Utils -------------------------------------------------------------
    function countBucketsFromString(sTmp){
      var b = {a:0,b:0,c:0,d:0,e:0,f:0,g:0,h:0,i:0,j:0};
      if (!sTmp) return b;
      var s = String(sTmp).toLowerCase();
      for (var k=0;k<s.length;k++){ var ch = s[k]; if (b.hasOwnProperty(ch)) b[ch]++; }
      return b;
    }
    function buildMailBody(b, alter, geschlecht, email){
      var out = [
        'Auswertung:',
        'a='+b.a,'b='+b.b,'c='+b.c,'d='+b.d,'e='+b.e,
        'f='+b.f,'g='+b.g,'h='+b.h,'i='+b.i,'j='+b.j,'',
        'Alter: '+(alter||''), 'Geschlecht: '+(geschlecht||''), 'eMail: '+(email||'')
      ];
      return out.join('\n');
    }
    function parseFragenTxt(txt){
      var lines = (txt||'').split(/\r?\n/), out=[];
      for (var i=0;i<lines.length;i++){
        var row = lines[i].trim();
        if (!row || row.indexOf('#')<0) continue;
        var parts = row.split('#');
        var q = (parts[0]||'').trim();
        var code = (parts[1]||'').trim();
        if (q && code) out.push({q:q, code:code});
      }
      return out;
    }

    // ---- Chips (Filter) ----------------------------------------------------
    var groups = {
      frau:       [6,22],
      mann:       [22],
      energie:    [1,18,28,29,31,32,35,38,40,47],
      ernaehrung: [4,5,10,15,19,27,30,34,39,42,48],
      haut:       [11,17,24,25,26,36,49],
      balance:    [2,3,7,8,12,14,22,23,37,41,43,44],
      psyche:     [9,13,16,20,21,33,45,46]
    };
    function applyFilter(key){
      var rows = Array.prototype.slice.call(wrap.querySelectorAll('.vo-sn-row'));
      rows.forEach(function(row, i){
        var qNum = i+1;                 // 1..N
        var isContact = qNum >= 50;     // 50–52
        if (isContact) { row.style.display = ''; return; }
        if (key === 'alle' || !groups[key]) row.style.display = '';
        else row.style.display = groups[key].indexOf(qNum) !== -1 ? '' : 'none';
      });
    }
    if (chipbar){
      chipbar.addEventListener('click', function(e){
        var btn = e.target.closest('button[data-chip]');
        if (!btn) return;
        chipbar.querySelectorAll('button').forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        applyFilter(btn.getAttribute('data-chip'));
      });
    }

    // ---- Formular aus vo-fragen.txt bauen ---------------------------------
    var questionsUrl = root.getAttribute('data-questions-url');
    var codesByIndex = []; // 1..N -> code (nur in JS, nicht im DOM)

    function renderFragen(fragen){
      wrap.innerHTML = '';
      for (var i=0;i<fragen.length;i++){
        var idx = i+1, item = fragen[i];
        codesByIndex[idx] = item.code; // Codes bleiben im JS

        var row = document.createElement('label');
        row.className = 'vo-sn-row';

        var span = document.createElement('span');
        span.textContent = idx+'. '+item.q;
        row.appendChild(span);

        var input;
        switch(item.code){
          case '1': // Alter
            input = document.createElement('input');
            input.type = 'text';
            input.name = 'contact[Alter]';
            input.inputMode = 'numeric';
            input.pattern = '[0-9]{1,3}';
            input.placeholder = 'z. B. 34';
            row.classList.add('vo-sn-input');
            break;
          case '2': // Geschlecht
            input = document.createElement('input');
            input.type = 'text';
            input.name = 'contact[Geschlecht]';
            input.placeholder = 'M / F / D';
            row.classList.add('vo-sn-input');
            break;
          case '3': // E-Mail
            input = document.createElement('input');
            input.type = 'email';
            input.name = 'contact[email]';
            input.required = true;
            input.placeholder = 'deine@beverzugte-email.xxx';
            row.classList.add('vo-sn-input');
            break;
          default:  // Checkbox Q1–Q49
            input = document.createElement('input');
            input.type = 'checkbox';
            input.className = 'vo-qcheck';
            input.setAttribute('data-idx', String(idx)); // aber kein Code im DOM
            input.name = 'contact[q'+String(idx).padStart(2,'0')+']';
            input.value = 'Ja';
        }
        row.appendChild(input);
        wrap.appendChild(row);
      }
      applyFilter('alle');
    }

    function fetchText(url){
      return fetch(url, { credentials:'same-origin' }).then(function(r){
        if (!r.ok) throw new Error('HTTP '+r.status);
        return r.text();
      });
    }

    if (questionsUrl){
      fetchText(questionsUrl)
        .then(parseFragenTxt)
        .then(renderFragen)
        .catch(function(err){
          wrap.innerHTML = '<div class="vo-sn-row">Fehler beim Laden der Fragen: '+err.message+'</div>';
        });
    }

    // ---- Submit: min. 1 Checkbox + Auswertung bauen -----------------------
    function hasAnyChecked() {
      var checks = form.querySelectorAll('.vo-qcheck');      // nur Q1..Q49
      if (!checks.length) return null;                       // noch nicht geladen
      for (var i = 0; i < checks.length; i++) if (checks[i].checked) return true;
      return false;
    }

    // Gemeinsame Block-Funktion
    function blockSubmit(e, msg, focusEl) {
      if (e) {
        // so hart wie möglich blocken:
        if (typeof e.preventDefault === 'function') e.preventDefault();
        if (typeof e.stopPropagation === 'function') e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      }
      openFlash('err', msg, 5000);
      if (focusEl) {
        try { focusEl.focus({preventScroll:false}); } catch(_) {}
        try { focusEl.scrollIntoView({block:'center', behavior:'smooth'}); } catch(_) {}
      }
    }

    // 1) Klick auf Submit-Button abfangen (bevor Theme-Skripte ggf. form.submit() rufen)
    var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function(e){
        var checks = form.querySelectorAll('.vo-qcheck');
        var state = hasAnyChecked();
        if (state === null) {
          blockSubmit(e, 'Bitte einen Moment – die Fragen werden noch geladen.', checks[0]);
          return;
        }
        if (state === false) {
          blockSubmit(e, 'Bitte wähle mindestens eine Frage mit „Ja“ aus, bevor du fortfährst.', checks[0]);
          return;
        }
        // ok -> nichts tun (Form darf weiter)
      }, true); // **capture**: vor anderen Click-Handlern im Theme
    }

    // 2) Zusätzlich den echten Submit abfangen (falls per Enter/Keyboard ausgelöst)
    form.addEventListener('submit', function(e){
      var checks = form.querySelectorAll('.vo-qcheck');
      var state = hasAnyChecked();
      if (state === null) {
        blockSubmit(e, 'Bitte einen Moment – die Fragen werden noch geladen.', checks[0]);
        return;
      }
      if (state === false) {
        blockSubmit(e, 'Bitte wähle mindestens eine Frage mit „Ja“ aus, bevor du fortfährst.', checks[0]);
        return;
      }

      // --- Auswertung bauen (wie bisher) ---
      var selectedIdx = Array.prototype.filter.call(checks, function(c){ return c.checked; })
        .map(function(c){ return Number(c.getAttribute('data-idx')) || 0; });

      var selectedCodes = selectedIdx.map(function(i){ return codesByIndex[i] || ''; });
      var sTmp = selectedCodes.join(',');
      var buckets = countBucketsFromString(sTmp);

      var alter = (form.querySelector('input[name="contact[Alter]"]')||{}).value || '';
      var geschlecht = (form.querySelector('input[name="contact[Geschlecht]"]')||{}).value || '';
      var email = (form.querySelector('input[name="contact[email]"]')||{}).value || '';
      hiddenOut.value = buildMailBody(buckets, alter, geschlecht, email);
    }, true); // **capture**: vor anderen Submit-Handlern

  }

  // Init für alle Container auf der Seite
  function initAll(){
    var roots = document.querySelectorAll('[data-vo-la="root"]');
    if (!roots.length){ // Backward: falls Attribut fehlt, versuche .vo-sn-la
      var fallback = document.querySelectorAll('.vo-sn-la');
      fallback.forEach(initRoot);
    } else {
      roots.forEach(initRoot);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
